import { render, staticRenderFns } from "./PopinError.vue?vue&type=template&id=56e5ad9a&"
import script from "./PopinError.vue?vue&type=script&lang=js&"
export * from "./PopinError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports